// TODO : zoom in on first story

import React, { Component } from "react";
import GoogleMapReact from "google-map-react";
import MapsPin from "./maps_pin.png";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  img: {
    height: 50,
    position: `relative`,
    cursor: `pointer`,
    transform: `translate(-50%, -100%)`,
  },
});

const Marker = (props) => {
  const { click } = props;
  const classes = useStyles();

  return (
    <img onClick={click} alt="Map Pin" src={MapsPin} className={classes.img} />
  );
};

export class GoogleMaps extends Component {
  render() {
    const { location, mapStyle } = this.props;

    return (
      <div style={{ height: 300, width: `100%`, margin: `30px 0` }}>
        <GoogleMapReact
          center={this.props.center}
          zoom={15}
          options={{ styles: mapStyle }}
        >
          <Marker lat={location.lat} lng={location.lng} />
        </GoogleMapReact>
      </div>
    );
  }
}

export default GoogleMaps;
